// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  openItem: ['dashboard'],
  openCollapseItem: [''],
  defaultId: 'dashboard',
  openComponent: 'buttons',
  drawerOpen: false,
  componentDrawerOpen: true,
  drawerHoverable: false
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeCollapseItem(state, action) {
      state.openCollapseItem = action.payload.openCollapseItem;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },
    toggleDrawerHoverable(state, action) {
      state.drawerHoverable = !state.drawerHoverable;
    }
  }
});

export default menu.reducer;

export const { activeItem, activeCollapseItem, activeComponent, openDrawer, openComponentDrawer, toggleDrawerHoverable } = menu.actions;
